import React, { Component } from "react";
import {
  IoMdTime,
  IoIosArrowDroprightCircle,
  IoIosArrowDropleftCircle,
  IoIosCalendar,
  IoMdPaper,
  IoIosPaper,
  IoMdPlay,
  IoMdAdd,
  IoIosAddCircle,
  IoMdClose,
} from "react-icons/io";
import { Row, Col, Button } from "antd";
import { IoPersonOutline } from "react-icons/io5";

import { ParsedDate } from "../../function/ParseDate";
// import axiosGlobal from "../../axios-global";

import "../../assets/css/publish.css";
import "../../assets/css/modal.css";

export default class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataPublishIds: [],
    };
  }
  componentDidMount() {
    this.setState({ dataPublishIds: this.props.v.publish_ids });
  }

  render() {
    return (
      <>
        {this.state.dataPublishIds.map((v, i) => {
          if (!v.detail) return null;
          return (
            <div className="card-publish" key={i}>
              <div className="card-inner">
                <div className="card-text">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "space-between",
                      justifyContent: "flex-end",
                      alignSelf: "baseline",
                      cursor: "pointer",
                      height: "12.5rem",
                    }}
                  >
                    <h4 style={{ fontSize: "1rem" }}>
                      {v.detail.publish_name}
                    </h4>

                    <h5 style={{ margin: "auto", fontSize: "13px" }}>
                      {v.detail.inst_name}
                    </h5>

                    <div className="row-icon">
                      <div style={{ display: "flex", marginLeft: "0" }}>
                        <IoPersonOutline className="icon" />
                        <p>{v.detail.participant_count}</p>
                      </div>
                      <div
                        style={{
                          backgroundColor: "lightgrey",
                          border: "0.5px solid lightgrey",
                          height: "1rem",
                        }}
                      ></div>
                      <div
                        style={{
                          display: "flex",
                          marginRight: "0",
                        }}
                      >
                        <IoMdTime className="icon" />
                        <p>{ParsedDate(v.detail.created_at)}</p>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        paddingBottom: "2.5rem",
                      }}
                    >
                      <IoIosCalendar className="icon" />
                      <p>
                        {ParsedDate(v.detail.started_at)} -
                        {" " + ParsedDate(v.detail.finished_at)}
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    position: "absolute",
                    bottom: "12px",
                    left: "0px",
                    paddingTop: "0.5rem",
                    display: "flex",
                    flexDirection: "row",
                    // justifyContent: "space-evenly",
                    alignItems: "center",
                  }}
                >
                  {/* position: "absolute" */}
                  {/* <div className="button-icons"> */}
                  <div
                    style={{
                      // backgroundColor: "green",
                      // width: "275px",
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "space-evenly",
                      alignContent: "center",
                      flexDirection: "row",
                    }}
                    className="button-icons"
                  >
                    {/* {false ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  marginLeft: "0.2rem",
                                  cursor: "not-allowed",
                                }}
                              >
                                <IoIosPaper
                                  className="btn-modal paper"
                                  style={{
                                    color: "lightsteelblue",
                                    cursor: "not-allowed",
                                  }}
                                />
                                <p className="text btn-inactive">
                                  Contoh
                                  <br />
                                  laporan
                                </p>
                              </div>
                            ) :  */}
                    {/* v.report_example false */}
                    {v.detail.report_example && (
                      <div
                        style={{
                          // display: "flex",
                          // flexDirection: "column",
                          // alignItems: "center",
                          // marginLeft: "0.2rem",
                          cursor: "pointer",
                          display: "flex",
                          flex: "1 1 auto",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          // this.fetchPublish();
                          this.props.onReport(v.detail);
                        }}
                      >
                        <IoIosPaper
                          // onClick={() => this.openReportModal(v)}
                          style={{ display: "flex", margin: "auto" }}
                          //  paper
                          className="btn-modal"
                        />
                        <p className="text btn-active">
                          Contoh
                          <br />
                          laporan
                        </p>
                      </div>
                    )}
                    {/* <div className="gap-icon"></div> */}
                    {/* v.video_url false*/}
                    {v.detail.video_url && (
                      //   <div
                      //     style={{
                      //       display: "flex",
                      //       flexDirection: "column",
                      //       alignItems: "center",
                      //       justifyContent: "center",
                      //       cursor: "not-allowed",
                      //     }}
                      //   >
                      //     <IoMdPlay
                      //       className="btn-modal video-add"
                      //       style={{
                      //         color: "lightsteelblue",
                      //         cursor: "not-allowed",
                      //       }}
                      //     />
                      //     <p
                      //       style={{
                      //         marginLeft: "1.4rem",
                      //       }}
                      //       className="text btn-inactive"
                      //     >
                      //       Video
                      //       <br />
                      //       tutorial
                      //     </p>
                      //   </div>
                      // ) : (
                      <div
                        style={{
                          // display: "flex",
                          // flexDirection: "column",
                          // alignItems: "center",
                          // justifyContent: "center",
                          cursor: "pointer",
                          display: "flex",
                          flex: "1 1 auto",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          // this.fetchPublish();
                          this.props.onVideo(v.detail);
                        }}
                      >
                        <IoMdPlay
                          // onClick={() => this.openVideoModal(v)}
                          //  video-add
                          className="btn-modal"
                        />
                        <p
                          // style={{
                          //   marginLeft: "1.4rem",
                          // }}
                          className="text btn-active"
                        >
                          Video
                          <br />
                          tutorial
                        </p>
                      </div>
                    )}
                    {/* <div className="gap-icon"></div> */}
                    <Button
                      onClick={() => this.props.onModal(v.detail)}
                      className="button-apply"
                      style={{ width: "120px" }}
                    >
                      <h5 style={{ color: "#fff" }}>Daftar paket</h5>
                    </Button>
                    {/* <div
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        flex: "1 1 auto",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                      onClick={() => this.props.onModal(v.detail)}
                    >
                      <IoIosAddCircle className="btn-modal" />
                      <p className="text btn-active">
                        Daftar
                        <br />
                        paket
                      </p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          );
          // {
          //   /* <div style={{ display: "flex", marginTop: "12px" }}>
          //             <img style={{ width: "30px" }} src={clock} alt="clock" />
          //             <p style={{ margin: "auto 8px" }}>
          //               {ParsedDate(v.started_at)} - {ParsedDate(v.finished_at)}
          //             </p>
          //           </div> */
          // }
        })}
      </>
    );
  }
}
